import React from 'react';

import { WpBreadcrumbs, WpBreadcrumbItem } from '../';

const BreadcrumbsDocs = () => {
  return (
    <div>
      breadcrumb docs
      <WpBreadcrumbs>
        <WpBreadcrumbItem label="one" to="/" />
        <WpBreadcrumbItem label="two" to="/" />
        <WpBreadcrumbItem label="three" to="/" />
      </WpBreadcrumbs>
    </div>
  );
};

export default BreadcrumbsDocs;
